import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { rows } from "./../MastersFakeDb";
import { editDeleteProduct, getProductList } from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import productMasterService from "../../../services/masters/productMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";

const ProductList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.product.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.product.rows_per_page || 15);
  // const rows = useSelector((state) => state.product.product);
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");

  const fields = ["prod_code", "prod_description", "product_group","prod_type"];
  const labels = ["Product Code", "Product Description", "	Product Group","	Product Type"];
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  // const [successMessage, setSuccessMessage] = useState(null);
  // const respMsgState = 'test'
  // const respMsgState = useSelector((state) => state.charges.message);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });
  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

   const fetchData = async () => {
      try {
        const params = {
          page: controller.page,
          size: controller.rowsPerPage,
          searchKey: searchKey,
        }
        const response = await productMasterService.getProductList (params);
        setRows(response);
      }
      catch (error) {
        console.error("Error fetching data:", error);
        setSuccessMessage("Error fetching data");
      }
    };


  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);  
    
   
    const params = {
        page: controller.page,
        size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
        searchKey: searchValue,
    };

    try {
       
        await fetchData(params);
    } catch (error) {
        console.error("Error in handleSearch:", error);
    }
};

  useEffect(() => {
    fetchData();
  }, [controller]);




    const deleteRecord = async (id) => {
      try {
        await productMasterService.editDeleteProduct ({
          prod_id: id,
          changedUpdatedValue: "delete"
        });
        setIsDelete(false);
        fetchData();
        setSuccessMessage("Record deleted successfully");
      } catch (error) {
        setSuccessMessage("Error deleting record");
      }
    };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const [successMessage, setSuccessMessage] = useState(null);







  
  const sortedRows = Array.isArray(rows)
  ? [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date))
  : [];

   const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });




  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[
          
            { name: "Product List" },
          ]}
        />


        <HeaderSection
          title="PRODUCT LIST"
          addNewPath="/masters/add-product"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Product List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />


        <Paper sx={{ width: '100%',  }}>
          <TableContainer
            component={Paper}
            className={`${styles.list_tbl_container}`}
          >
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>

                  <StyledTableCell
                    className={`${styles.table_head}`}
                    align="left"
                    onClick={() =>
                      HandleSort("prod_code", sortBy, setSortBy, rows)
                    }
                  >
                    Product Code
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "prod_code" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    className={`${styles.table_head}`}
                    sx={{ width: '30%' }}
                    align="left"
                    onClick={() =>
                      HandleSort("prod_description", sortBy, setSortBy, rows)
                    }
                  >
                    Product Description
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "prod_description" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                 
                  <StyledTableCell
                    className={`${styles.table_head}`}
                    align="left"
                    onClick={() =>
                      HandleSort("prod_group", sortBy, setSortBy, rows)
                    }
                  >
                    Product Group
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "prod_group" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    className={`${styles.table_head}`}
                    align="left"
                    onClick={() =>
                      HandleSort("prod_type", sortBy, setSortBy, rows)
                    }
                  >
                    Product Type
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "prod_type" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    className={`${styles.table_head}`}
                  >
                    Action
                  </StyledTableCell>

                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) &&
                  rows.map((row, index) => (
                    <StyledTableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >

                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        {row.prod_code}
                      </StyledTableCell>
                     
                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        {row.prod_description}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        {row.prod_group}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        {row.prod_type}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomePopover
                          row={row}
                          handleDelete={false}
                          linkTo="/masters/add-product"
                           handlePrint ={false}
                              handleCancel={false}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
                       <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.prod_id || null}
          displayName={deleteInfo?.prod_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};
export default ProductList;
